import { Component, Signal } from '@angular/core'
import {
    SESSION_ACTIVITY_TYPE_ANYTHING,
    SESSION_ACTIVITY_TYPE_DESK,
    SESSION_ACTIVITY_TYPE_MOVING,
    SESSION_DURATION_25_MINS,
    SESSION_DURATION_50_MINS,
    SESSION_DURATION_75_MINS,
    SessionActivityType,
} from '@app/core/_models'
import { SelectButtonChangeEvent, SelectButtonModule } from 'primeng/selectbutton'
import {
    faLampDesk,
    faPersonWalking,
    faShuffle,
    faVolumeSlash,
} from '@fortawesome/pro-solid-svg-icons'
import { FormsModule } from '@angular/forms'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { SessionSettingsService } from '@app/core/_services/session-settings.service'
import { ToggleSwitchModule } from 'primeng/toggleswitch'
import { CommonModule } from '@angular/common'
import { FP_TOGGLE_SWITCH } from '@app/focus-prime/tokens/toggleswitch'
import { ButtonModule } from 'primeng/button'

const DurationButtonToken = {
    root: {
        borderRadius: '8px',
        fontSize: '8px',
    },
    secondary: {
        background: '#fff',
        color: '#2f3150',
        activeBackground: '#f2e8dc',
        borderColor: '#f2e8dc',
    },
    lg: {
        fontSize: '12px',
        paddingX: '4px',
    },
}

interface ActivityOption {
    icon: any
    label: string
    value: SessionActivityType
    next: number
}

const ACTIVITY_OPTIONS: ActivityOption[] = [
    { icon: faLampDesk, label: 'Desk', value: SESSION_ACTIVITY_TYPE_DESK, next: 1 },
    { icon: faPersonWalking, label: 'Moving', value: SESSION_ACTIVITY_TYPE_MOVING, next: 2 },
    { icon: faShuffle, label: 'Anything', value: SESSION_ACTIVITY_TYPE_ANYTHING, next: 0 },
]

interface DurtionOption {
    label: string
    value: number
    next: number
}

const DURATION_OPTIONS: DurtionOption[] = [
    { label: '25', value: SESSION_DURATION_25_MINS, next: 1 },
    { label: '50', value: SESSION_DURATION_50_MINS, next: 2 },
    { label: '75', value: SESSION_DURATION_75_MINS, next: 0 },
]

@Component({
    selector: 'fm-booking-hub-session-settings',
    imports: [
        CommonModule,
        ButtonModule,
        SelectButtonModule,
        ToggleSwitchModule,
        FormsModule,
        FontAwesomeModule,
    ],
    templateUrl: './booking-hub-session-settings.component.html',
    styleUrl: './booking-hub-session-settings.component.scss',
})
export class BookingHubSessionSettingsComponent {
    public token = DurationButtonToken
    public expandSettingsPanel = false

    // Activity
    public activityValue: ActivityOption
    public activityOptions = ACTIVITY_OPTIONS

    // Duration
    public durationValue: DurtionOption
    public durationOptions = DURATION_OPTIONS

    // Quiet Mode
    public quietMode: boolean
    public faVolumeSlash = faVolumeSlash
    public toggleSwitchToken = FP_TOGGLE_SWITCH

    constructor(public sessionSettingsService: SessionSettingsService) {
        this.quietMode = this.sessionSettingsService.quietModeEnabled()
    }

    ngOnInit() {
        // Session settings
        const duration = this.sessionSettingsService.sessionDurationSetting()
        this.durationValue = this.durationOptions.find((item) => item.value === duration)
        const activity = this.sessionSettingsService.getSessionSettingActivityType()
        this.activityValue = this.activityOptions.find((item) => item.value === activity)
    }

    toggleDuration() {
        const next = this.durationValue.next
        this.durationValue = this.durationOptions[next]
        this.sessionSettingsService.setSessionDurationSetting(this.durationValue.value)
    }

    onSelectedDuration(event: SelectButtonChangeEvent): void {
        this.durationValue = this.durationOptions.find((element) => element.value == event.value)
        this.sessionSettingsService.setSessionDurationSetting(this.durationValue.value)
    }

    toggleActivity() {
        const next = this.activityValue.next
        this.activityValue = this.activityOptions[next]
        this.sessionSettingsService.setSessionSettingActivityType(this.activityValue.value)
    }
    onSelectedActivity(event: SelectButtonChangeEvent): void {
        this.activityValue = this.activityOptions.find((element) => element.value == event.value)
        this.sessionSettingsService.setSessionSettingActivityType(this.activityValue.value)
    }

    disableQuietMode(): void {
        this.sessionSettingsService.setSessionSettingQuietMode(false)
        this.quietMode = false
    }

    onToggleQuietMode(event: any) {
        this.sessionSettingsService.setSessionSettingQuietMode(event.checked)
    }
}
